import React from 'react';
import PropTypes from 'prop-types';
import { AddressPropTypes } from 'utils/PropTypesValues';
import { Typography, Box } from '@material-ui/core';

const ShippingAddress = ({ address, classes }) => {
  return (
    <Box data-testid="shipping-address-box">
      <Typography data-testid="address-fullName" className={classes?.shippingLine}>
        {address.firstName} {address.lastName}
      </Typography>
      <Typography data-testid="address-line1" className={classes?.shippingLine}>
        {address.line1}
      </Typography>
      <Typography data-testid="address-line2" className={classes?.shippingLine}>
        {address.line2}
      </Typography>
      <Typography
        data-testid="address-full-line"
        className={classes?.fullLine}
      >{`${address.city}, ${address.state} ${address.country} ${address.zip}`}</Typography>
    </Box>
  );
};

ShippingAddress.propTypes = {
  address: AddressPropTypes,
  classes: PropTypes.shape({}),
};

ShippingAddress.defaultProps = {
  address: {},
  classes: {},
};

export default ShippingAddress;
